import axios from 'axios';

import { store } from '@app/redux/store';

import * as environment from '@utils/environment';

const httpClient = axios.create({
	baseURL: environment.env.API_URL,
});

httpClient.interceptors.request.use(async config => {
	const accessToken = store.getState().auth.tokens?.access_token;
	const branchEnvironment = store.getState().branchEnvironment.variables.branch_id;

	config.headers = config.headers || {};

	// Set Authorization header if token exists
	if (accessToken) {
		config.headers.Authorization = `Bearer ${accessToken}`;
	}

	// Set custom branch header
	if (branchEnvironment) {
		config.headers.branch = branchEnvironment;
	}

	return config;
});

export default httpClient;
